// extracted by mini-css-extract-plugin
export default {"dragContainer":"styles__dragContainer___WSprq","dragIcon":"styles__dragIcon___FLjkt","dragInput":"styles__dragInput___UyYfb"};